import { useTranslation } from 'react-i18next';
import { prettyMoney } from '@scramble/utils';
import s from './index.module.scss';

export const BonusInfo = ({ totalBonusAmount }) => {
  const { t } = useTranslation();
  return (
    <div className={s.wrapper}>
      <div className={s.title}>{t('investing:bonus_info.bonuses_offers')}</div>
      <div className={s.block}>
        <div className={s.row}>
          <div className={s.row_left}>
            <span>{t('investing:bonus_info.total_bonuses')}</span>
            <span>{t('investing:bonus_info.bonuses_credited')}</span>
          </div>
          <div className={s.row_right}>
            <span className="f-500">{prettyMoney(totalBonusAmount)}</span>
          </div>
        </div>
      </div>
    </div>
  );
};
